import { ExperimentRoot } from './ExperimentRoot';
import { ExperimentVariant } from './ExperimentVariant';

export const Experiment = Object.assign(ExperimentRoot, {
  Variant: ExperimentVariant,
});

export { FeatureFlag } from './FeatureFlag';
